@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  // section is  just for semantics if a header is present
  display: contents;
}

// header
.header {
}

// main
.main {
  overflow: auto;
  // The following styles are just to center the text.
  display: flex;
  align-items: center;
  justify-content: center;
}

// footer
.footer {
}
